import AddressSearch from 'components/AddressSearch';
import Loading from 'components/Loading';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store/rootReducer';
import styled from 'styled-components';
import RenderAfterNavermapsLoaded from 'utils/RenderAfterNavermapsLoaded';
import GapBldInfoModal from './GapBldInfoModal';
import GapMap from './GapMap';

function GapMapHome() {
  const mapStore = useSelector((state: RootState) => state.mapStore);

  return (
    <>
      <Container>
        <AddressSearch />
        <RenderAfterNavermapsLoaded
          ncpClientId={`${process.env.REACT_APP_NAVER_MAP_KEY}`}
          error={<Loading />}
          loading={<Loading />}
        >
          <GapMap zoom={17} />
        </RenderAfterNavermapsLoaded>
      </Container>
      {mapStore.modal && <GapBldInfoModal />}
    </>
  );
}

export default GapMapHome;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
`;
